export type Props = {
  chipData: any
  variant?: string
  size?: string
  chipKey?: string
  chipLabel?: string
  chipDelete?: boolean
  onChipDelete?: (e: any) => any
  showTooltip?: boolean
  tooltipText?: string
  sx?: Array<object> | object
  additionalProps?: any
}

export const DefaultProps = {
  variant: 'outlined',
  size: 'small',
  chipKey: 'key',
  chipLabel: 'label',
  chipDelete: false,
  showTooltip: false,
  tooltipText: 'Delete',
  sx: {},
  additionalProps: {},
}
